<template lang="pug">
.giftcard-forgot-container

  substrate(v-if="showModal" @close="showModal = false" inner-class="substrate__popup-change-pass-padd")
    re-toast-alert.m-t-20.m-b-20(v-if="errorMessage" type="danger") {{ errorMessage }}
    p Resend your code using the email address associated with your Gift Card <b>OR</b> your Gift Card Number.
    div
      label Email Address
      input(v-model="email" type="text" :disabled="this.$v.number.required")
    .separate
      p OR
    div
      label Gift Card Number
      input(v-model="number" type="number" :disabled="this.$v.email.required")
    div
      v-button.site_button(@click="recover" :loading="isSubmitting" :disabled="disabledSubmit" no-default-class native-type="button")
        span Submit

  substrate(v-if="showSentModal" @close="showSentModal = false" inner-class="substrate__popup-change-pass-padd substrate__popup-forgot-code-success")
    div
      re-toast-alert.m-t-50(v-if="errorMessage" type="danger") {{ errorMessage }}
      p.substrate__popup-change-pas__caption Success
      p The Gift Card code has been sent to the following email address {{ recoveredEmail }}.
      div
        p.substrate__popup-change-pass__resend(style='display:block') If you have not received an email please click on the 
          v-button.btn-link(@click="resend" :loading="isSubmitting" no-default-class) resend
          |  link.

  substrate(v-if="showResentModal" @close="showResentModal = false" inner-class="substrate__popup-change-pass-padd substrate__popup-forgot-code-success")
    p The Gift Card code has been resent to the following email address {{ recoveredEmail }}.

</template>

<script>
import axios from 'axios'
import { required, email, helpers } from 'vuelidate/lib/validators'

import { getFirstErrorMessage } from '~/lib/axios'

import ConfigMixin from '../../_mixins/config'
import PagesMixin from '../../_mixins/pages'

export default {
  name: 're-giftcard-forgot',

  mixins: [
    ConfigMixin,
    PagesMixin,
  ],

  data: () => ({
    email: null,
    number: null,
    recoveredEmail: null,
    isSubmitting: false,
    errorMessage: null,
    showModal: false,
    showSentModal: false,
    showResentModal: false,
  }),

  validations: {
    email: {
      required,
      email,
    },
    number: {
      required,
      digits: helpers.regex('digits', /^[0-9]*$/)
    },
  },

  computed: {
    disabledSubmit() {
      return (this.$v.email.required && this.$v.number.required) ||
        (this.$v.email.$invalid && this.$v.number.$invalid)
    },
  },

  methods: {
    show() {
      this.showModal = true
    },

    async forgot(giftcard) {
      this.payload = null
      this.endpoint = `${giftcard.id}/clubspeed/send-cvv`
      await this.submit(() => {
        this.showSentModal = true
        this.recoveredEmail = giftcard.recipient.data.email
      })
    },

    async recover() {
      if (!this.$v.email.$invalid) {
        this.payload = {
          email: this.email,
        }
        this.endpoint = 'clubspeed/send-cvv-by-email'
      } else {
        this.payload = {
          number: this.number,
        }
        this.endpoint = 'clubspeed/send-cvv'
      }
      await this.submit(response => {
        this.showModal = false
        this.showSentModal = true
        this.recoveredEmail = response.email
      })
    },

    async resend() {
      await this.submit(() => {
        this.showResentModal = true
      })
    },

    async submit(callback) {
      try {
        this.isSubmitting = true
        const { data } = await axios.post(`${this.config.apiUri}/customer/giftcard/${this.endpoint}`, this.payload)
        this.errorMessage = null
        callback(data)
      } catch (e) {
        this.errorMessage = getFirstErrorMessage(e)
      } finally {
        this.isSubmitting = false
      }
    },
  },
}
</script>

<style lang="scss">
.giftcard-forgot-container {
  .substrate__popup-change-pass input {
    border: 1px solid #BEBEBE;
    width: 100%;
    height: 50px;
  }
  button.btn-link {
    padding: 0;
    border: 0;
    height: fit-content;
    font-family: 'OpenSans-Regular';
    text-decoration: underline;
    font-size: 16px;
    color: #B31E23;
    line-height: 1.3;
  }
  .separate p {
    font-weight: bold;
    font-size: 14px;
    opacity: 1;
    line-height: 1.4;
  }
}
</style>
